define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/onboarding_com_en/js/onboarding-container/1.0.0/js/vm-service/index-impl',
  'readingiq-src/js/riq-js/riq-group-model-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-user-model-service/1.0.0/index',
  'readingiq-src/js/riq-js/group-state-service/1.0.0/index'
  /* eslint-enable */
], function onboardingVmService(app, onboardingVmServiceImpl) {
  'use strict';

  app.registerFactory('onboardingVmService', [
    '$state',
    'riqUserModelService',
    'riqApiService',
    onboardingVmServiceImpl
  ]);
});
